import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/pengerjaan/tryout";

export default {
  request(id) {
    return Client.get(`${resource}/request/${id}`);
  },
  kerjakan(id) {
    return Client.get(`${resource}/kerjakan/${id}`);
  },
  startPaketMapel(pengerjaanId, paketKategoriId, paketMapelId) {
    return Client.post(`${resource}/${pengerjaanId}/paket-kategori/${paketKategoriId}/paket-mapel/${paketMapelId}/start`);
  },
  show(id) {
    return Client.get(`${resource}/detail/${id}`);
  },
  simpanJawaban(id, payload) {
    return Client.post(`${resource}/simpan/${id}`, payload);
  },
  review(id) {
    return Client.get(`${resource}/review/${id}`);
  },
  histories(id) {
    return Client.get(`${resource}/histories/${id}`);
  },
  score(id) {
    return Client.get(`${resource}/score/${id}`);
  },
  akhiriSesi(id) {
    return Client.post(`${resource}/akhiri-sesi/${id}`);
  },
  /**
   * Get user's tryout history (completed tryouts)
   * @param {number} page - Page number (default 1)
   * @param {number} pageSize - Items per page (default 10)
   * @returns {Promise} API response with history data and pagination
   */
  getHistory(page = 1, pageSize = 10) {
    return Client.get(`${resource}/history?page=${page}&page_size=${pageSize}`);
  },
};
